import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { StyledTextField } from './styles'
import { InputAdornment } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import LabelContainer from 'components/ui-kit/LabelContainer/index'
import { StyledTooltip } from '../Tooltip/styles'

const CustomTextField = ({
  name,
  helperText,
  label,
  placeholder,
  inputRef,
  fullWidth,
  variant,
  type,
  disabled,
  required,
  InputProps,
  error,
  size,
  rows,
  onChange,
  value,
  enablevalidation,
  labeltype,
  ...otherProps
}) => {
  const [showPassword, setShowPassword] = useState(false)
  const [customizeType, setCustomizeType] = useState('password')

  const Adornment = ({ error, tooltipTitle }) => {
    return (
      <>
        <InputAdornment
          position='end'
          sx={{ backgroundColor: (theme) => theme.colors.white }}
        >
          {error
            ? (
              <StyledTooltip
                title={tooltipTitle}
                placement='top'
                arrow
                type='error'
              >
                <ErrorOutlineIcon color='error' />
              </StyledTooltip>
              )
            : (
              <CheckCircleOutlineIcon color='success' />
              )}
        </InputAdornment>
      </>
    )
  }

  return (
    <LabelContainer
      showPassword={showPassword}
      setShowPassword={setShowPassword}
      setCustomizeType={setCustomizeType}
      isPasswordField={type === 'password'}
      type={labeltype}
      label={label}
      required={required}
    >
      <StyledTextField
        autoComplete='off'
        inputRef={inputRef}
        fullWidth={!!fullWidth}
        name={name}
        variant={variant}
        type={type === 'password' ? customizeType : type}
        required={required}
        disabled={disabled}
        placeholder={placeholder}
        helperText={labeltype !== 'filter' ? error || helperText : undefined}
        error={labeltype !== 'filter' ? !!error : undefined}
        size={size}
        rows={rows}
        onChange={onChange}
        value={value}
        labeltype={labeltype}
        InputProps={InputProps || {
          endAdornment:
            enablevalidation && labeltype !== 'filter'
              ? (
                  value && <Adornment error={error} tooltipTitle={helperText} />
                )
              : (
                <></>
                )
        }}
        {...otherProps}
      />
    </LabelContainer>
  )
}

export default CustomTextField

CustomTextField.defaultProps = {
  label: '',
  enablevalidation: false,
  disabled: false,
  type: 'string',
  fullWidth: true,
  variant: 'outlined',
  inputRef: null,
  placeholder: '',
  error: undefined,
  helperText: null,
  size: 'medium',
  multiline: false,
  onChange: () => {},
  value: '',
  name: '',
  labeltype: 'default',
  required: true
}

CustomTextField.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) })
  ]),
  fullWidth: PropTypes.bool,
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard']),
  type: PropTypes.string,
  disabled: PropTypes.bool,
  InputProps: PropTypes.shape({}),
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  helperText: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  multiline: PropTypes.bool,
  rows: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any.isRequired,
  enablevalidation: PropTypes.bool,
  labeltype: PropTypes.oneOf(['filter', 'default', 'dateFilter']),
  required: PropTypes.bool
}
